/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import SqlImportModel from 'cio/models/sql-import';
import ApiErrorsService from 'cio/services/api-errors';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';

interface SqlImportsConfirmAndToggleStatusArgs {
  model: SqlImportModel;
  onClose: () => unknown;
}

export default class SqlImportsConfirmAndToggleStatus extends Component<SqlImportsConfirmAndToggleStatusArgs> {
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service apiErrors!: ApiErrorsService;

  get verb() {
    return this.args.model.active ? 'pause' : 'activate';
  }

  toggleStatusTask = dropTask(async () => {
    let { model } = this.args;

    try {
      if (model.active) {
        await model.stop({});
        this.alerts.success('sql-import.paused', `Paused ${model.name}`);
      } else {
        await model.start({});
        this.alerts.success('sql-import.activated', `Activated ${model.name}`);
      }

      this.args.onClose();
    } catch (err) {
      this.apiErrors.report(err);
    }
  });

  @action
  trackEvent() {
    this.analytics.track('sql_imports', !this.args.model.active ? 'sync_activate_started' : 'sync_pause_started');
  }
}
